/*
 * @Descripttion: 
 * @Author: heng.wu
 * @Date: 2022-8-9 14:26:29
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2022-8-9 14:26:21
 */
import https from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'

// 配送员列表查询
export const deliveryQuery = (params:any) => {
  return https().request('delivery', Method.GET, params, ContentType.form)
}


